import { Component } from '@angular/core';

@Component({
  selector: 'app-main-loading',
  imports: [],
  templateUrl: './main-loading.component.html',
  styleUrl: './main-loading.component.scss',
})
export class MainLoadingComponent {
}
